/**
 * Base URL for the Express API (no trailing slash).
 *
 * CRA (`npm start`) usually binds port 3000. If API_BASE incorrectly pointed at
 * the same port, `fetch(.../api/...)` would receive `index.html` and
 * `res.json()` would throw: Unexpected token '<', "<!DOCTYPE "... is not valid JSON.
 * Default to 3001 so local dev matches a typical API port (set PORT in server
 * `.env` or use REACT_APP_API_URL when different).
 */
export const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/$/, '');
